import { forwardRef } from 'react';
import { textareaClass } from './twClasses';

const TwTextarea = forwardRef(function TwTextarea({ className = '', ...props }, ref) {
  return (
    <textarea
      ref={ref}
      className={className ? `${textareaClass} ${className}` : textareaClass}
      {...props}
    />
  );
});

export default TwTextarea;
